import { Pipe, PipeTransform } from '@angular/core';
import { CommonService } from '@ecosure-suite/shared/utils-helpers';

@Pipe({
  name: 'age'
})
export class AgePipe implements PipeTransform {
  transform(value: any): string {
    const age = CommonService.getAge(value);
    return `${age.value} ${age.name}`;
  }
}
